import { combineReducers } from '@reduxjs/toolkit';

import Handbook from './slices/handbook';
import navbarReducer from './slices/navbar';
import Notifications from './slices/notifications';
import PrescriptionFilters from './slices/prescriptionFilters';
import Prescriptions from './slices/prescriptions';
import sidebarReducer from './slices/sidebar';
import toastsReducer from './slices/toasts';
import userReducer from './slices/user';

const rootReducer = combineReducers({
  navbar: navbarReducer,
  sidebar: sidebarReducer,
  toasts: toastsReducer,
  user: userReducer,
  handbook: Handbook,
  prescriptions: Prescriptions,
  prescriptionFilters: PrescriptionFilters,
  notifications: Notifications,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
